export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    id: "faq-1",
    question: "换了一台设备，笔笔漫画网的收藏还能找回吗？",
    answer:
      "可以。只要在新设备上登录同一个账号，并确保设置里的「收藏自动同步」已开启，稍等片刻让收藏数据拉取完成，之前的收藏就会恢复显示。建议换设备前先确认旧设备已正常登录且同步状态为开启。",
  },
  {
    id: "faq-2",
    question: "同一个账号可以在手机和电脑上同时登录吗？",
    answer:
      "可以。笔笔漫画网支持多设备同时在线，手机和电脑可以登录同一个账号并共享收藏、阅读进度等数据。只需注意在两台设备上保持同步开关开启，即可无缝切换阅读。",
  },
  {
    id: "faq-3",
    question: "为什么有些漫画点击后显示图片加载失败？",
    answer:
      "多数情况是当前漫画源暂时不稳定或网络波动导致。可以刷新页面、切换网络，或使用「换源」功能切换到其他可用的源。如果所有源都异常，通常说明该作品暂时维护中，过一会儿再试即可。",
  },
  {
    id: "faq-4",
    question: "不小心清了缓存，我的收藏和阅读进度会没吗？",
    answer:
      "只要你是登录状态，收藏和阅读进度都存在账号云端，不会因清理本地缓存而丢失。清理后重新登录即可恢复。如果清理前已退出登录，请先登录原账号再查看。",
  },
  {
    id: "faq-5",
    question: "搜索关键词太复杂搜不到怎么办？",
    answer:
      "建议把搜索词精简为核心关键词，例如只输入主角名或漫画的关键字。也可以尝试不同写法，简体繁体互换、去掉空格，或者直接到分类页按类型浏览，往往能找到想看的作品。",
  },
  {
    id: "faq-6",
    question: "登录验证码一直收不到是什么原因？",
    answer:
      "先检查手机短信或邮箱的拦截与垃圾箱，确认填写的账号号码无误后重新发送。发送频率过高会被系统短时限制，稍等几分钟再试。若长期收不到，可尝试更换登录方式或联系客服协助。",
  },
];